"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _TableRow = require("./TableRow.styles");
var _excluded = ["aria-selected", "children", "onClick"];
/**
 * A native [`<tr>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/tr) element.
 *
 * @since 8.0.0
 */
var TableRow = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var ariaSelected = _ref['aria-selected'],
    children = _ref.children,
    onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_TableRow.StyledTableRow, (0, _extends2.default)({
    "aria-selected": ariaSelected,
    onClick: onClick,
    ref: forwardedRef
  }, rest), _react.Children.map(children, function (child, index) {
    return child && /*#__PURE__*/(0, _react.cloneElement)(child, {
      index: index
    });
  }));
});
exports.TableRow = TableRow;
TableRow.displayName = 'Table.Row';
TableRow.propTypes = {
  /**
   * If true, displays the row in its "selected" state.
   *
   * @since 8.19.0
   */
  'aria-selected': _propTypes.default.bool,
  /**
   * The table cells. An index is added to each child cell for use by `TableSortableHeaderCell`.
   */
  'children': _propTypes.default.node.isRequired,
  /**
   * If true, the row's background color will change on hover. Primarily used
   * in conjuction with `onClick` and `aria-selected` to indicate a row is selectable.
   * It can also be used to help show the user where they are within a larger table.
   *
   * @since 8.19.0
   */
  'interactive': _propTypes.default.bool,
  /**
   * Callback function that's called whenever you click on the row.
   * Be sure to add `stopPropagation` to any clickable child elements
   * (ex: buttons or links).
   */
  'onClick': _propTypes.default.func
};